import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {StatusChipComponent} from '@aviary/components/status-chip/status-chip.component';
import {CHECKOUT_CLAIM_TYPE_CHIP_COLORS, CheckoutClaim, DISPLAYABLE_CHECKOUT_CLAIM_TYPE} from '@store/checkouts/checkouts.types';
import {CheckoutsSelectors} from '@store/checkouts/checkouts.selectors';
import {OutlinedButtonComponent} from '@aviary/buttons/outlined-button/outlined-button.component';
import {Store} from '@ngrx/store';
import {CheckoutsActions} from '@store/checkouts/checkouts.actions';
import {MatChipSet} from '@angular/material/chips';

@Component({
  selector: 'px-claims-mobile-column',
  host: {
    class: 'w-full flex flex-col items-end gap-y-4'
  },
  template: `
    <mx-outlined-button startIcon="text_snippet" tooltip="Details" (click)="onClickDetailsButton()"/>

    <mat-chip-set>
      <mx-status-chip [status]="selectors.typeFor(claim) | select" [colors]="CHECKOUT_CLAIM_TYPE_CHIP_COLORS"
                      [displayableStatusNames]="DISPLAYABLE_CHECKOUT_CLAIM_TYPE"/>
    </mat-chip-set>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe, StatusChipComponent, OutlinedButtonComponent, MatChipSet]
})
export class ClaimsMobileColumnComponent {
  @Input({required: true}) public claim: CheckoutClaim;

  public readonly CHECKOUT_CLAIM_TYPE_CHIP_COLORS = CHECKOUT_CLAIM_TYPE_CHIP_COLORS;
  public readonly DISPLAYABLE_CHECKOUT_CLAIM_TYPE = DISPLAYABLE_CHECKOUT_CLAIM_TYPE;
  public readonly selectors = CheckoutsSelectors.Claims;

  private store: Store = inject(Store);

  public onClickDetailsButton(): void {
    this.store.dispatch(CheckoutsActions.showViewClaim(this.claim));
  }
}
